import { FilterOperator, OrderType, useSearchExamCoursesQuery } from '@exam-center/graphql';
import { useNavigate } from '@exam-center/router';
import { type GridCellParams } from '@shared/components';

import { BaseAdminExamCourseDataGrid } from '../../components';
import { useAdminExamCourseListSearchParams } from '../../hooks';
import { AdminExamCourseListNoRowsOverlay } from '../admin-exam-course-list-no-rows-overlay';

import { columns } from './columns';

export default function AdminExamCourseList() {
  const [{ page, pageSize }, { changePageNumber, changePageSize }] =
    useAdminExamCourseListSearchParams();
  const navigate = useNavigate();

  const { loading: isLoading, data } = useSearchExamCoursesQuery({
    variables: {
      searchExamCoursesInput: {
        filter: {
          conditions: [
            {
              field: 'enabled',
              operator: FilterOperator.Equal,
              value: true,
            },
          ],
        },
        paging: {
          currentPage: page,
          pageSize,
        },
        order: {
          field: 'examId',
          type: OrderType.Asc,
        },
      },
    },
  });

  const examCourses = data?.ecSearchExamCourses?.examCourses ?? [];
  const total = data?.ecSearchExamCourses?.total ?? 0;

  const handleCellClick = (cell: GridCellParams) => {
    navigate('/admin/exam-courses/:examCourseCode/details', {
      params: { examCourseCode: cell.row.code },
    });
  };

  return (
    <BaseAdminExamCourseDataGrid
      columns={columns}
      rows={examCourses}
      loading={isLoading}
      onCellClick={handleCellClick}
      hideFooter={total === 0}
      slots={{
        noRowsOverlay: AdminExamCourseListNoRowsOverlay,
      }}
      slotProps={{
        footer: {
          total,
          pagination: {
            page,
            count: total,
            rowsPerPage: pageSize,
            onPageChange: (_, page) => changePageNumber(page),
            onRowsPerPageChange: (event) => changePageSize(parseInt(event.target.value)),
          },
        },
      }}
    />
  );
}
